// extracted by mini-css-extract-plugin
export default {"applePayButton":"ApplePayCard_applePayButton__3Uyw2","socialButtonsOr":"ApplePayCard_socialButtonsOr__09qmV","socialButtonsOrText":"ApplePayCard_socialButtonsOrText__PitSd"};